import { APIURL } from '../constant/apiConstant'
import ApiService from './apiRequest'
import AsyncStorageFunc from '../utilities/asyncStorage';

export const getOptOut = async (params) => {
  let token = await AsyncStorageFunc.getData('TOKEN');
  let deviceId = await AsyncStorageFunc.getData('deviceId');
  const header = {
    Authorization: token ? "bearer " + token : "",
    deviceId: deviceId
  };
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.MAX_PRO_OPT_OUT, params, header)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export const getMPFAQS = async () => {
  return new Promise((resolve, reject) => {
    ApiService.getWithToken(APIURL.GET_MAX_PRO_FAQ+`?useCase=MAX_PRO`, {},)
      .then(res => {
        resolve(res?.data || []);
      }).catch(err => {  reject(err); });
  });
};
 
export const getOptIn = params => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.MAX_PRO_OPT_IN, params)
      .then(res => {
        resolve(res);
      }).catch(err => { reject(err); });
  });
}

export const getAllVehiclesListMPEnabled = () => {
  return new Promise((resolve, reject) => {
    ApiService.getWithToken(APIURL.GET_ALL_VEHICLES_MAX_PRO_ENABLED)
      .then(res => {
        resolve(res?.data || []);
      })
      .catch(err => {
        reject(err);
      });
  });
};
  